// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"676":"648093c3","804":"a8d5176f","821":"a8d5176f","830":"ea24a1e5","876":"a8d5176f"}[chunkId] + ".css";
};